import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  signal,
  WritableSignal,
  model,
  input,
  ChangeDetectionStrategy,
  TemplateRef,
} from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { ChipsItem } from '../../types/chips';
import { UBaseInfraComponent } from '../u-base-infra.component';
import { UiIconModel } from '../../types/ui.icon.model';

@Component({
  selector: 'u-chips',
  templateUrl: './u-chips.component.html',
  styleUrls: ['./u-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UChipsComponent extends UBaseInfraComponent {
  @Output() itemsChanged = new EventEmitter<ChipsItem[] | any>();
  @ViewChild('chipInput') chipInputRef: ElementRef<HTMLInputElement>;

  separatorKeysCodes = signal<number[]>([ENTER, COMMA]);

  items = model<ChipsItem[] | any>([]);
  isInputActive: WritableSignal<boolean> = signal(false);
  showShortUrl = input<boolean>(false);
  location = input<'outside' | 'inside'>('outside');
  outsideType = input<'border' | 'not-border'>('not-border');
  @Input() itemTemplate?: TemplateRef<any>;

  remove(item: ChipsItem) {
    const updated = this.items().filter((i) => i !== item);
    this.items.set(updated);
    this.itemsChanged.emit(updated);
  }

  getIconRef() {
    return null;
  }

  iconModel(item: ChipsItem): UiIconModel {
    const v = item?.icon;
    if (!v) return null;
    if (typeof v === 'string') {
      return { type: 'font', value: v };
    }
    return v as UiIconModel;
  }
}
